import { ActionTree } from 'vuex';
import { ProjectComplet, StateInterface } from '@/interfaces/projects';
import { Project } from '../../interfaces/projects';

const actions: ActionTree<ProjectComplet, StateInterface> = {
    setProject(state, project: Project) {
        state.commit("setProject",project);
    },
    setProjectClient (state, client) {
        state.commit("setProjectClient",client);
    },
    setProjectDocuments(state, documents) {
        state.commit("setProjectDocuments",documents);
    },
    setProjectSamples(state, samples: number) {
        state.commit("setProjectSamples",samples);
    },
    setProjectTotal(state, total: number) {
        state.commit("setProjectTotal",total);
    },
    setProjectReview(state, review: number) {
        state.commit("setProjectReview",review);
    },
    setProjectReviewError(state, reviewError: number) {
        state.commit("setProjectReviewError",reviewError);
    },
    setIsSearching(state, isSearching: boolean) {
        state.commit("setIsSearching",isSearching);
    },
    setCurrentDate(state, currentDate: string) {
        state.commit("setCurrentDate",currentDate);
    },
    setNewDocsToday(state, newDocsToday: number) {
        state.commit("setNewDocsToday",newDocsToday);
    },
    setPrioritario(state, prioritario: number) {
        state.commit("setPrioritario",prioritario);
    },
    setReviewPending(state, reviewPending: number) {
        state.commit("setReviewPending",reviewPending);
    },
    setReviewedToday(state, reviewedToday: number) {
        state.commit("setReviewedToday",reviewedToday);
    },
}



export default actions;